import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-ion-expense-chip',
    templateUrl: './ion-expense-chip.component.html',
    styleUrls: ['./ion-expense-chip.component.scss'],
    standalone: false
})
export class IonExpenseChipComponent implements OnInit {


  constructor() { }

  ngOnInit() {}

  @Input() item_state_name: string;
  @Input() size_ion_chip: string;
}
